import { render, staticRenderFns } from "./BillItem.vue?vue&type=template&id=aa46f252&scoped=true"
import script from "./BillItem.vue?vue&type=script&lang=js"
export * from "./BillItem.vue?vue&type=script&lang=js"
import style0 from "./BillItem.vue?vue&type=style&index=0&id=aa46f252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa46f252",
  null
  
)

export default component.exports